import { Link, useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="container flex h-full min-h-[75vh] flex-col items-center justify-center bg-white py-6 md:py-8">
      <div className="relative">
        <h1 className="text-9xl font-extrabold tracking-widest text-neutral-700">
          404
        </h1>
        <div className="absolute top-[64%] left-1/2 -translate-x-1/2 rotate-12 rounded bg-primaryGreen px-2 text-sm text-neutral-100">
          Page Not Found
        </div>
      </div>
      <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
        <div className="group relative text-sm font-medium text-primaryGreen focus:outline-none focus:ring">
          <span className="absolute inset-0 translate-x-0.5 translate-y-0.5 bg-neutral-700 transition-transform group-hover:translate-y-0 group-hover:translate-x-0" />
          <Link
            to="/"
            className="relative block bg-primaryGreen px-8 py-3 text-neutral-100 no-underline"
          >
            Go Home
          </Link>
        </div>
        <div className="group relative text-sm font-medium text-primaryGreen focus:outline-none focus:ring">
          <span className="absolute inset-0 translate-x-0.5 translate-y-0.5 bg-neutral-700 transition-transform group-hover:translate-y-0 group-hover:translate-x-0" />
          <span
            role="button"
            onClick={() => navigate(-1)}
            className="relative block bg-primaryGreen px-8 py-3 text-neutral-100 no-underline"
          >
            Go Back
          </span>
        </div>
      </div>
    </div>
  );
}
